import { useAuth } from "@clerk/clerk-react";
import { useMediaQuery, useTheme } from "@mui/material";
import { AlertContext } from "contexts/Alert";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { OrganizationUserContext } from "contexts/Organization";
import { UserIntegrationsContext } from "contexts/UserIntegrations";
import { useContext } from "react";
import { MessageAttachment } from "schemas/email";

import { fetcherAuth } from "utils/api";
import { openBase64DataInTab } from "utils/files";

export const useOutreachTable = () => {
  const { setErrorAlert } = useContext(AlertContext);
  const { getToken } = useAuth();
  const { currentOrg } = useContext(OrganizationUserContext);
  const { userIntegration } = useContext(UserIntegrationsContext);

  const { discoverTab } = useContext(DiscoverViewContext);

  const theme = useTheme();
  const isMobileScreen = useMediaQuery("(max-width:1325px)");
  const isLargeScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const isSmallScreen =
    isMobileScreen || (isLargeScreen && discoverTab !== null);

  const openAttachment = async (
    messageId: string,
    attachment: MessageAttachment,
  ) => {
    try {
      const res = await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg?.id}/user-integrations/${userIntegration?.id}/messages/${messageId}/attachments/${attachment.attachment_id}`,
        "GET",
      );
      openBase64DataInTab(res.attachment.data, attachment.mime_type);
    } catch (error) {
      setErrorAlert(error);
    }
  };

  return { openAttachment, isSmallScreen };
};
